export type Lang = 'th' | 'en';

const th = {
  'brand.name': 'TMRM',
  'brand.subtitle': 'Risk Management',
  'brand.tagline': 'ระบบบริหารความเสี่ยงระดับคณะ',

  'lang.thai': 'ไทย',
  'lang.english': 'ENG',

  'nav.home': 'Dashboard',
  'nav.riskRegister': 'ทะเบียนความเสี่ยง',
  'nav.registerNewRisk': 'ขึ้นทะเบียนความเสี่ยงใหม่',
  'nav.departments': 'หน่วยงาน',
  'nav.users': 'ผู้ใช้',
  'nav.roles': 'จัดการบทบาท',

  'common.account': 'บัญชี',
  'common.logout': 'ออกจากระบบ',
  'common.cancel': 'ยกเลิก',
  'common.save': 'บันทึก',
  'common.add': 'เพิ่ม',
  'common.edit': 'แก้ไข',
  'common.delete': 'ลบ',
  'common.view': 'ดู',
  'common.close': 'ปิด',
  'common.search': 'ค้นหา...',
  'common.actions': 'การจัดการ',
  'common.status': 'สถานะ',
  'common.owner': 'ผู้รับผิดชอบ',
  'common.evidence': 'หลักฐาน',
  'common.department': 'หน่วยงาน',
  'common.fiscalYear': 'ปีงบประมาณ',
  'common.riskCode': 'รหัสความเสี่ยง',
  'common.riskName': 'ชื่อความเสี่ยง',
  'common.riskType': 'ประเภทความเสี่ยง',
  'common.strategy': 'ยุทธศาสตร์',
  'common.riskManagementType': 'ประเภทการบริหารความเสี่ยง',
  'common.ermLevel': 'ระดับ ERM',
  'common.inherent': 'ความเสี่ยงก่อนควบคุม',
  'common.residual': 'ความเสี่ยงหลังควบคุม',
  'common.riskId': 'รหัสระบุความเสี่ยง (Risk ID)',
  'common.type': 'ประเภท',
  'common.items': '{n} รายการ',
  'common.impactType': 'ส่งผลกระทบด้าน',
  'common.impactTo': 'ส่งผลกระทบระดับ',
  'common.planPeriod': 'ช่วงระยะเวลาดำเนินการและกำหนดเสร็จ',
  'common.assessmentResult': 'ผลประเมิน',
  'common.measurementDate': 'วันที่วัดผล',
  'common.output': 'ผลการดำเนินกิจกรรม',
  'common.rcCode': 'รหัส RC',
  'common.ermRiskCode': 'รหัส ERM',
  'common.causes': 'สาเหตุ',
  'common.internalControls': 'การควบคุมภายใน',
  'common.kri': 'ตัวชี้วัดความเสี่ยง',
  'common.masterRisk': 'ความเสี่ยงหลัก',
  'common.masterRiskCode': 'รหัสความเสี่ยงหลัก',
  'common.masterView': 'ตามยุทธศาสตร์',
  'common.allView': 'ตามหน่วยงาน',
  'common.years': 'ปี',
  'common.loading': 'กำลังโหลด...',
  'common.likelihood': 'โอกาสเกิด',
  'common.impact': 'ผลกระทบ',

  'level.high': 'สูง',
  'level.medium': 'ปานกลาง',
  'level.low': 'ต่ำ',
  'level.veryHigh': 'สูงมาก',

  'strategy.R': 'ด้านวิจัย',
  'strategy.T': 'ด้านการศึกษา',
  'strategy.A': 'ด้านบริการวิชาการ',
  'strategy.H': 'ด้านบริการสุขภาพ',
  'strategy.G': 'ด้านบริหาร',
  'rmt.Acceptance': 'การยอมรับ',
  'rmt.Reduction': 'การลด',
  'rmt.Transfer': 'การถ่ายโอน',
  'rmt.Avoidance': 'การหลีกเลี่ยง',

  'erm.dept': 'Dept',
  'erm.erm': 'ERM',
  'erm.department': 'ระดับหน่วยงาน',
  'erm.faculty': 'ระดับคณะ (ERM)',

  'login.username': 'ชื่อผู้ใช้',
  'login.password': 'รหัสผ่าน',
  'login.usernamePlaceholder': 'กรอกชื่อผู้ใช้',
  'login.passwordPlaceholder': 'กรอกรหัสผ่าน',
  'login.signIn': 'เข้าสู่ระบบ',
  'login.failed': 'เข้าสู่ระบบล้มเหลว กรุณาลองใหม่อีกครั้ง',

  'dashboard.title': 'การบริหารความเสี่ยง คณะเวชศาสตร์เขตร้อน',
  'dashboard.allDepartments': 'ทุกหน่วยงาน',
  'dashboard.allFiscalYears': 'ทุกปีงบประมาณ',
  'dashboard.allLevels': 'ทุกระดับ',
  'dashboard.levelDepartment': 'ระดับหน่วยงาน',
  'dashboard.levelFaculty': 'ระดับคณะ (ERM)',
  'dashboard.exportDoc3': 'ERM_doc3.xlsx',
  'dashboard.exportDoc4': 'ERM_doc4.xlsx',
  'dashboard.exportDoc3Pdf': 'เอกสารหมายเลข 3 (PDF)',
  'dashboard.exportDoc4Pdf': 'เอกสารหมายเลข 4 (PDF)',
  'dashboard.totalRisks': 'ความเสี่ยงทั้งหมด',
  'dashboard.highRisks': 'ความเสี่ยงสูง',
  'dashboard.mediumRisks': 'ความเสี่ยงปานกลาง',
  'dashboard.lowRisks': 'ความเสี่ยงต่ำ',
  'dashboard.veryHighRisks': 'ความเสี่ยงสูงมาก',
  'dashboard.ermLevel': 'ระดับ ERM',
  'dashboard.deptLevel': 'ระดับหน่วยงาน',
  'dashboard.facultyLevel': 'ระดับคณะ',
  'dashboard.departmentLevel': 'ระดับหน่วยงาน',
  'dashboard.internalControls': 'มาตรการควบคุมภายใน (IC)',
  'dashboard.additionalControls': 'มาตรการควบคุมเพิ่มเติม (AC)',
  'dashboard.kriIndicators': 'ตัวชี้วัด KRI',
  'dashboard.riskStatus': 'สถานะความเสี่ยง',
  'dashboard.open': 'เปิด',
  'dashboard.approved': 'อนุมัติ',
  'dashboard.rejected': 'ไม่อนุมัติ',
  'dashboard.heatMap': 'การประเมินความเสี่ยง',
  'dashboard.riskSummary': 'สรุปความเสี่ยง',
  'dashboard.highImmediate': 'ต้องดำเนินการทันที',
  'dashboard.mediumMonitor': 'เฝ้าระวังและบริหารจัดการ',
  'dashboard.lowAcceptable': 'ระดับที่ยอมรับได้',
  'dashboard.veryHighImmediate': 'วิกฤต ต้องจัดการทันที',
  'dashboard.coverageRisks': 'ครอบคลุม {a}/{b} ความเสี่ยง',
  'dashboard.percentRisksPlanned': '{p}% ความเสี่ยงมีแผน',
  'dashboard.kriTracking': 'ตัวชี้วัดที่กำลังติดตาม',
  'dashboard.departmentTargets': 'เป้าหมายหน่วยงาน',
  'docs.exportSuccess': 'ส่งออกเอกสารสำเร็จ',
  'docs.exportError': 'ส่งออกเอกสารล้มเหลว',
  'docs.selectFiscalYear': 'กรุณาเลือกปีงบประมาณก่อนส่งออก',

  'riskRegister.title': 'ทะเบียนความเสี่ยง',
  'riskRegister.addRisk': 'เพิ่มความเสี่ยง',
  'riskRegister.copySelected': 'คัดลอกที่เลือก ({n})',
  'riskRegister.totalRisks': 'ทั้งหมด: {n} ความเสี่ยง',
  'riskRegister.totalMasters': 'ทั้งหมด: {n} ความเสี่ยงหลัก',
  'riskRegister.risksCount': '{n} ความเสี่ยง',
  'riskRegister.inherent': 'ก่อนควบคุม',
  'riskRegister.residual': 'หลังควบคุม',
  'riskRegister.viewExpand': 'ดู / ขยาย',
  'riskRegister.copyNextYear': 'คัดลอกไปปีถัดไป',
  'riskRegister.elevateErm': 'เลื่อนเป็นระดับ ERM',
  'riskRegister.removeErm': 'ถอดออกจากระดับ ERM',
  'riskRegister.edit': 'แก้ไข',
  'riskRegister.delete': 'ลบ',
  'riskRegister.confirmDelete': 'ลบความเสี่ยงนี้ถาวร? การกระทำนี้ไม่สามารถย้อนกลับได้',
  'riskRegister.deleted': 'ลบความเสี่ยงแล้ว',
  'riskRegister.deleteError': 'ลบความเสี่ยงล้มเหลว',
  'riskRegister.requestDelete': 'ส่งคำขอลบ',
  'riskRegister.masterRisk': 'ความเสี่ยงหลัก',
  'riskRegister.createMasterRisk': 'สร้างความเสี่ยงหลัก',
  'riskRegister.selectMasterRisk': 'เลือกความเสี่ยงหลัก',
  'riskRegister.requestDeleteSuccess': 'ส่งคำขอลบให้ผู้จัดการแล้ว',
  'riskRegister.requestDeleteError': 'ส่งคำขอลบล้มเหลว',
  'riskRegister.pendingDeletions': 'คำขอลบใกล้ ({n})',
  'riskRegister.noPendingDeletions': 'ไม่มีคำขอลบใกล้',
  'riskRegister.approveDelete': 'อนุมัติลบ',
  'riskRegister.rejectDelete': 'ปฏิเสธ',
  'riskRegister.approveDeleteSuccess': 'อนุมัติลบสำเร็จ',
  'riskRegister.rejectDeleteSuccess': 'ปฏิเสธคำขอลบแล้ว',
  'riskRegister.inherentLikelihood': 'โอกาสเกิด (ก่อนควบคุม)',
  'riskRegister.inherentImpact': 'ผลกระทบ (ก่อนควบคุม)',
  'riskRegister.inherentRisk': 'ความเสี่ยงก่อนควบคุม',
  'riskRegister.residualRisk': 'ความเสี่ยงหลังควบคุม',
  'riskRegister.residualLikelihood': 'โอกาสเกิด (หลังควบคุม)',
  'riskRegister.residualImpact': 'ผลกระทบ (หลังควบคุม)',
  'riskRegister.editMasterRisk': 'แก้ไขความเสี่ยงหลัก',
  'riskRegister.report': 'รายงานผล',
  'riskRegister.addMasterRisk': 'เพิ่มความเสี่ยงหลัก',
  'riskRegister.addAssessment': 'เพิ่มการประเมิน',
  'riskRegister.editAssessment': 'แก้ไขการประเมิน',
  'riskRegister.riskManagementType': 'ประเภทการบริหารความเสี่ยง',
  'riskRegister.loadError': 'โหลดข้อมูลความเสี่ยงล้มเหลว',
  'riskRegister.selectAllDept': 'เลือกทั้งหมดในหน่วยงาน',
  'riskRegister.selectRisk': 'เลือก {code}',

  'section.causes': 'สาเหตุความเสี่ยง ({n})',
  'section.internalControls': 'แผนที่มีในปัจจุบัน ({n})',
  'section.additionalControls': 'แผนเพิ่มเติม ({n})',
  'section.kri': 'ตัวชี้วัดความเสี่ยง ({n})',
  'section.addCause': 'เพิ่มสาเหตุ',
  'section.addIc': 'เพิ่ม IC',
  'section.addAc': 'เพิ่ม AC',
  'section.addKri': 'เพิ่ม KRI',
  'section.cause': 'สาเหตุ',
  'section.noCauses': 'ยังไม่มีสาเหตุ',
  'section.noIcs': 'ยังไม่มีมาตรการควบคุมภายใน',
  'section.noAcs': 'ยังไม่มีแผนเพิ่มเติม',
  'section.noKris': 'ยังไม่มีตัวชี้วัด',
  'section.noKri': 'ยังไม่มีตัวชี้วัด',
  'section.target': 'ค่าเป้าหมาย',
  'section.result': 'ผลลัพธ์',
  'section.confirmDeleteCause': 'ลบสาเหตุนี้?',
  'section.confirmDeleteIc': 'ลบมาตรการควบคุมภายในนี้?',
  'section.confirmDeleteAc': 'ลบแผนเพิ่มเติมนี้?',
  'section.confirmDeleteKri': 'ลบตัวชี้วัดนี้?',
  'section.added': 'เพิ่มเรียบร้อย',
  'section.updated': 'อัปเดตเรียบร้อย',
  'section.deleted': 'ลบเรียบร้อย',
  'section.error': 'เกิดข้อผิดพลาด',

  'modal.addCause': 'เพิ่มสาเหตุความเสี่ยง',
  'modal.editCause': 'แก้ไขสาเหตุความเสี่ยง',
  'modal.addIc': 'เพิ่มมาตรการควบคุมภายใน',
  'modal.editIc': 'แก้ไขมาตรการควบคุมภายใน',
  'modal.addAc': 'เพิ่มมาตรการควบคุมเพิ่มเติม',
  'modal.editAc': 'แก้ไขมาตรการควบคุมเพิ่มเติม',
  'modal.addKri': 'เพิ่มตัวชี้วัด KRI',
  'modal.editKri': 'แก้ไขตัวชี้วัด KRI',
  'modal.causeId': 'รหัสสาเหตุ',
  'modal.number': 'ลำดับ',
  'modal.causeDescription': 'รายละเอียดสาเหตุ',
  'modal.icId': 'รหัส IC',
  'modal.icNo': 'ลำดับ IC',
  'modal.acId': 'รหัส AC',
  'modal.acNo': 'ลำดับ AC',
  'modal.description': 'รายละเอียด',
  'modal.icOwner': 'ผู้รับผิดชอบ IC',
  'modal.acOwner': 'ผู้รับผิดชอบ AC',
  'modal.controlType': 'ประเภทการควบคุม',
  'modal.evidence': 'ไฟล์หลักฐาน',
  'modal.autoHint': 'Auto (เว้นว่างได้)',
  'modal.kriId': 'รหัส KRI',
  'modal.kriName': 'ชื่อตัวชี้วัด',
  'modal.targetValue': 'ค่าเป้าหมาย',
  'modal.unit': 'หน่วย',
  'modal.kriOwner': 'ผู้รับผิดชอบ KRI',
  'modal.actualResult': 'ผลลัพธ์จริง',
  'modal.actualResultPlaceholder': 'กรอกผลลัพธ์จริง',
  'modal.kriForm': 'ตัวชี้วัดความเสี่ยง',
  'modal.kriInfo': 'ข้อมูลตัวชี้วัด (KRI)',
  'modal.measurementDate': 'วันที่วัดผล',
  'modal.output': 'ผลการดำเนินกิจกรรม',
  'modal.outputPlaceholder': 'กรอกผลการดำเนินกิจกรรม',
  'modal.outputSection': 'ผลการดำเนินกิจกรรม (ข้อมูลความเสี่ยง)',
  'modal.reportResult': 'รายงานผลดำเนินการ',

  'copy.title': 'คัดลอกความเสี่ยงไปปีถัดไป',
  'copy.risk': 'ความเสี่ยง',
  'copy.currentYear': 'ปีปัจจุบัน',
  'copy.nextYear': 'ปีงบประมาณถัดไป',
  'copy.description': 'สำเนาจะคัดลอกข้อมูลทั้งหมด (สาเหตุ, IC, AC, KRI) ไปยังปีถัดไป โดยปีเดิมยังคงอยู่ครบถ้วน และระดับ ERM เริ่มต้นที่ระดับหน่วยงาน (Dept) ให้ผู้ดูแลระบบเลื่อนระดับภายหลัง',
  'copy.andEdit': 'คัดลอกและแก้ไขปีใหม่',
  'copy.selectTargetWarning': 'กรุณาเลือกปีเป้าหมาย',
  'copy.success': 'คัดลอกไปยัง {year} สำเร็จ',
  'copy.noNextYear': 'ไม่มีปีงบประมาณถัดไป ({year}) ในระบบ กรุณาเพิ่มปีงบประมาณก่อน',
  'copy.titleBatch': 'คัดลอกความเสี่ยงที่เลือกไปปีถัดไป',
  'copy.selected': 'ที่เลือก ({n})',
  'copy.descriptionBatch': 'ความเสี่ยงที่เลือกแต่ละรายการจะคัดลอกไปยังปีถัดไปของตนเอง รายการที่คัดลอกไปแล้วจะถูกข้ามโดยอัตโนมัติ',
  'copy.complete': 'คัดลอกกลุ่มเสร็จสิ้น',
  'copy.nothing': 'ไม่มีการคัดลอก',
  'copy.copied': 'คัดลอกแล้ว: {n}',
  'copy.alreadyExisted': 'มีอยู่แล้ว: {n}',
  'copy.noLongerExists': 'ไม่มีอยู่แล้ว: {n}',
  'copy.noNextYearCount': '{n} รายการไม่มีปีถัดไป',
  'copy.failed': 'ล้มเหลว: {list}',
  'copy.copying': 'กำลังคัดลอก...',
  'copy.copyCount': 'คัดลอก {n} รายการ',
  'copy.copiedTo': 'คัดลอกไปยัง {year} สำเร็จ',

  'form.titleNew': 'ขึ้นทะเบียนความเสี่ยงใหม่',
  'form.titleEdit': 'แก้ไขความเสี่ยง',
  'form.alertNew': 'ขึ้นทะเบียนความเสี่ยงใหม่ หลังสร้างแล้วสามารถเพิ่มสาเหตุ มาตรการควบคุม และ KRI ได้จากหน้าทะเบียนความเสี่ยง',
  'form.alertEdit': 'แก้ไขรายละเอียดความเสี่ยงด้านล่าง',
  'form.riskId': 'รหัสระบุความเสี่ยง (Risk ID)',
  'form.riskCode': 'รหัสความเสี่ยง',
  'form.department': 'หน่วยงาน',
  'form.fiscalYear': 'ปีงบประมาณ',
  'form.riskType': 'ประเภทความเสี่ยง',
  'form.strategy': 'ยุทธศาสตร์',
  'form.riskManagementType': 'ประเภทการบริหารความเสี่ยง',
  'form.riskOwner': 'ผู้รับผิดชอบความเสี่ยง',
  'form.ermLevel': 'ระดับ ERM',
  'form.riskName': 'ชื่อความเสี่ยง',
  'form.riskIdPlaceholder': 'เช่น RM-0001',
  'form.riskIdAuto': 'ระบบจะสร้างให้อัตโนมัติเมื่อบันทึก',
  'form.riskCodePlaceholder': 'เช่น OR01',
  'form.selectDepartment': 'เลือกหน่วยงาน',
  'form.selectFiscalYear': 'เลือกปีงบประมาณ',
  'form.selectRiskType': 'เลือกประเภทความเสี่ยง',
  'form.selectStrategy': 'เลือกยุทธศาสตร์',
  'form.selectRmt': 'เลือกประเภทการบริหารความเสี่ยง',
  'form.riskOwnerPlaceholder': 'ชื่อผู้รับผิดชอบความเสี่ยง',
  'form.riskNamePlaceholder': 'อธิบายความเสี่ยง...',
  'form.inherentLikelihood': 'โอกาสเกิด (ก่อนควบคุม)',
  'form.inherentImpact': 'ผลกระทบ (ก่อนควบคุม)',
  'form.residualLikelihood': 'โอกาสเกิด (หลังควบคุม)',
  'form.residualImpact': 'ผลกระทบ (หลังควบคุม)',
  'form.inherentRisk': 'ความเสี่ยงก่อนควบคุม',
  'form.residualRisk': 'ความเสี่ยงหลังควบคุม',
  'form.riskAssessment': 'การประเมินความเสี่ยง',
  'form.createRisk': 'ขึ้นทะเบียนความเสี่ยง',
  'form.updateRisk': 'อัปเดตความเสี่ยง',
  'form.cancel': 'ยกเลิก',
  'form.fillRequired': 'กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน',
  'form.updatedSuccess': 'อัปเดตความเสี่ยงสำเร็จ',
  'form.createdSuccess': 'ขึ้นทะเบียนความเสี่ยงสำเร็จ',
  'form.createdHeading': 'ขึ้นทะเบียนความเสี่ยงสำเร็จ',
  'form.registerAnother': '+ ขึ้นทะเบียนความเสี่ยงอื่น',
  'form.savedMessage': 'ความเสี่ยง <b>{code}</b> ถูกบันทึกแล้ว คุณสามารถแก้ไข ลบ หรือเพิ่มสาเหตุ/มาตรการควบคุมได้จากหน้าทะเบียนความเสี่ยง',
  'form.backToRegister': 'กลับไปหน้าทะเบียน',
  'form.editRisk': 'แก้ไขความเสี่ยง',
  'form.deleteRisk': 'ลบความเสี่ยง',
  'form.deletedSuccess': 'ลบความเสี่ยงแล้ว',
  'form.saveError': 'บันทึกความเสี่ยงล้มเหลว',
  'form.deleteError': 'ลบความเสี่ยงล้มเหลว',
  'form.riskNameLabel': 'ชื่อความเสี่ยง',
  'form.impactType': 'ส่งผลกระทบด้าน',
  'form.impactTo': 'ส่งผลกระทบระดับ',
  'form.planStartMonth': 'เดือนเริ่มต้น',
  'form.planEndMonth': 'เดือนสิ้นสุด',
  'form.assessmentResult': 'ผลประเมินกิจกรรมการควบคุมที่มีอยู่',
  'form.output': 'ผลการดำเนินกิจกรรม',
  'form.outputPlaceholder': 'กรอกผลการดำเนินกิจกรรม',
  'form.selectOption': 'เลือก',
  'form.rcCode': 'รหัส RC',
  'form.ermRiskCode': 'รหัส ERM',
  'form.riskCodeAuto': 'ระบบจะสร้างให้อัตโนมัติเมื่อบันทึก',

  'dept.title': 'หน่วยงาน',
  'dept.add': 'เพิ่มหน่วยงาน',
  'dept.unitId': 'รหัสหน่วยงาน',
  'dept.departmentName': 'ชื่อหน่วยงาน',
  'dept.workUnit': 'หน่วยงานย่อย',
  'dept.targets': 'เป้าหมาย',
  'dept.risks': 'ความเสี่ยง',
  'dept.addTitle': 'เพิ่มหน่วยงาน',
  'dept.editTitle': 'แก้ไขหน่วยงาน',
  'dept.unitIdPlaceholder': 'เช่น DEP-01',
  'dept.namePlaceholder': 'ชื่อหน่วยงาน',
  'dept.workUnitPlaceholder': 'หน่วยงานย่อย (ไม่บังคับ)',
  'dept.updatedSuccess': 'อัปเดตสำเร็จ',
  'dept.createdSuccess': 'สร้างสำเร็จ',
  'dept.deletedSuccess': 'ลบสำเร็จ',
  'dept.saveError': 'บันทึกล้มเหลว',
  'dept.deleteError': 'ลบหน่วยงานล้มเหลว',
  'dept.confirmDelete': 'คุณแน่ใจหรือไม่ที่จะลบหน่วยงานนี้?',
  'dept.view': 'ดู',
  'dept.recentActivity': 'กิจกรรมล่าสุด ({n})',
  'dept.noActivity': 'ยังไม่มีกิจกรรม',
  'dept.relatedTargets': 'เป้าหมายที่เกี่ยวข้อง ({n})',
  'dept.noTargets': 'ไม่พบเป้าหมาย',
  'dept.targetId': 'รหัสเป้าหมาย',
  'dept.targetNo': 'ลำดับ',
  'dept.targetDescription': 'รายละเอียด',
  'dept.relatedRisks': 'ความเสี่ยงที่เกี่ยวข้อง ({n})',
  'dept.noRisks': 'ไม่พบความเสี่ยง',
  'dept.riskName': 'ชื่อความเสี่ยง',
  'dept.riskType': 'ประเภท',

  'users.title': 'จัดการผู้ใช้ ({n})',
  'users.addUser': 'เพิ่มผู้ใช้',
  'users.export': 'ส่งออก',
  'users.username': 'ชื่อผู้ใช้',
  'users.fullName': 'ชื่อ-นามสกุล',
  'users.email': 'อีเมล',
  'users.role': 'บทบาท',
  'users.status': 'สถานะ',
  'users.admin': 'ผู้ดูแลระบบ',
  'users.user': 'ผู้ใช้',
  'users.active': 'ใช้งาน',
  'users.inactive': 'ระงับ',
  'users.noDept': 'ไม่ระบุแผนก',
  'users.addTitle': 'เพิ่มผู้ใช้',
  'users.editTitle': 'แก้ไข: {name}',
  'users.department': 'หน่วยงาน',
  'users.selectDept': 'เลือกหน่วยงาน',
  'users.newPassword': 'รหัสผ่านใหม่',
  'users.password': 'รหัสผ่าน',
  'users.usernamePlaceholder': 'เช่น somchai.k',
  'users.namePlaceholder': 'ชื่อ-นามสกุล',
  'users.emailPlaceholder': 'email@mahidol.ac.th',
  'users.passwordPlaceholder': 'กรอกรหัสผ่าน',
  'users.newPasswordPlaceholder': 'กรอกรหัสผ่านใหม่',
  'users.generate': 'สร้างรหัสผ่าน',
  'users.copy': 'คัดลอก',
  'users.passwordCopied': 'คัดลอกรหัสผ่านแล้ว',
  'users.keepCurrentPassword': 'เว้นว่างเพื่อคงรหัสผ่านเดิม',
  'users.fillRequired': 'กรุณากรอกข้อมูลให้ครบถ้วน',
  'users.updatedSuccess': 'อัปเดตสำเร็จ',
  'users.createdSuccess': 'สร้างสำเร็จ',
  'users.deletedSuccess': 'ลบสำเร็จ',
  'users.saveError': 'บันทึกล้มเหลว',
  'users.deleteError': 'ลบผู้ใช้ล้มเหลว',
  'users.confirmDelete': 'คุณแน่ใจหรือไม่ที่จะลบผู้ใช้นี้?',
  'users.genPasswordError': 'สร้างรหัสผ่านล้มเหลว',
  'users.exportError': 'ส่งออกล้มเหลว',
  'users.show': 'แสดง',
  'users.hide': 'ซ่อน',
  'users.selectRoleHint': 'กด Ctrl/Cmd ค้างเพื่อเลือกหลายบทบาท',

  'roles.title': 'จัดการบทบาท',
  'roles.addRole': 'เพิ่มบทบาท',
  'roles.name': 'ชื่อบทบาท',
  'roles.users': 'ผู้ใช้',
  'roles.addTitle': 'เพิ่มบทบาทใหม่',
  'roles.editTitle': 'แก้ไขบทบาท',
  'roles.namePlaceholder': 'ชื่อบทบาท',
  'roles.fillRequired': 'กรุณากรอกชื่อบทบาท',
  'roles.updatedSuccess': 'อัปเดตบทบาทสำเร็จ',
  'roles.createdSuccess': 'สร้างบทบาทสำเร็จ',
  'roles.saveError': 'บันทึกล้มเหลว',
  'roles.confirmDelete': 'คุณแน่ใจหรือไม่ที่จะลบบทบาทนี้?',
  'roles.deletedSuccess': 'ลบบทบาทสำเร็จ',
  'roles.deleteError': 'ลบบทบาทล้มเหลว',
  'roles.assignUsers': 'กำหนดผู้ใช้',
  'roles.assignTitle': 'กำหนดผู้ใช้ให้บทบาท: {role}',
  'roles.noUsers': 'ไม่มีผู้ใช้ในระบบ',
  'roles.assignSuccess': 'บันทึกการกำหนดผู้ใช้สำเร็จ',
  'roles.assignError': 'บันทึกการกำหนดผู้ใช้ล้มเหลว',

  'heatmap.impact': 'ผลกระทบ (Impact) ↑',
  'heatmap.likelihood': 'โอกาสเกิด (Likelihood) →',
  'heatmap.tooltip': 'โอกาส: {l} × ผลกระทบ: {i} = {s} | ระดับ: {lv} | ความเสี่ยง: {c}',
  'heatmap.legend': 'ระดับความเสี่ยง: เขียว: ต่ำ | เหลือง: ปานกลาง | ส้ม: สูง | แดง: สูงมาก',
  'heatmap.noData': 'ไม่มีข้อมูล',

  'icac.title': 'ความครอบคลุมของแผน IC/AC และไฟล์หลักฐาน',
  'icac.totalMasters': 'ความเสี่ยงหลักทั้งหมด',
  'icac.mastersWithIc': 'ความเสี่ยงหลักมีแผน IC',
  'icac.mastersWithAc': 'ความเสี่ยงหลักมีแผน AC',
  'icac.icWithEvidence': 'แผน IC มีหลักฐาน',
  'icac.acWithEvidence': 'แผน AC มีหลักฐาน',

  'pb.byCategory': 'สัดส่วนตามประเภทความเสี่ยง',
  'pb.byDepartment': 'จำนวนความเสี่ยงรายหน่วยงาน',
  'pb.byDepartmentInherent': 'จำนวนความเสี่ยงรายหน่วยงานตามระดับความเสี่ยงก่อนควบคุม',
  'pb.deptAnalysis': 'การวิเคราะห์รายหน่วยงาน',
  'pb.avgInherentVsResidual': 'คะแนนเฉลี่ยก่อน/หลังควบคุมรายหน่วยงาน (เฉพาะที่ประเมิน Residual แล้ว)',
  'pb.deptSummary': 'สรุปรายหน่วยงาน',
  'pb.residualCompleteness': 'ความครบถ้วนข้อมูล Residual: {p}% ({a}/{t})',
  'pb.residualHeatMap': 'การประเมินความเสี่ยงหลังควบคุม',
  'pb.avgControls': 'มาตรการควบคุมเฉลี่ยต่อความเสี่ยงรายหน่วยงาน',
  'pb.riskDetails': 'รายละเอียดความเสี่ยง',
  'pb.avgInherent': 'เฉลี่ยก่อนควบคุม',
  'pb.avgResidual': 'เฉลี่ยหลังควบคุม',
  'pb.totalRisks': 'ความเสี่ยงทั้งหมด',
  'pb.total': 'รวม',
  'pb.riskCode': 'รหัสความเสี่ยง',
  'pb.riskName': 'ชื่อความเสี่ยง',
  'pb.inherentRisk': 'ก่อนควบคุม',
  'pb.department': 'หน่วยงาน',

  'upload.uploadEvidence': 'อัปโหลดหลักฐาน',
  'upload.replaceFile': 'เปลี่ยนไฟล์',
  'upload.uploaded': 'อัปโหลดไฟล์สำเร็จ',
  'upload.failed': 'อัปโหลดล้มเหลว',
  'upload.view': 'เปิดไฟล์',
  'upload.remove': 'ลบ',
  'upload.evidence': 'หลักฐาน',
};

const en: Record<string, string> = {
  'brand.name': 'TMRM',
  'brand.subtitle': 'Risk Management',
  'brand.tagline': 'Faculty Risk Management System',

  'lang.thai': 'ไทย',
  'lang.english': 'ENG',

  'nav.home': 'Dashboard',
  'nav.riskRegister': 'Risk Register',
  'nav.registerNewRisk': 'Register New Risk',
  'nav.departments': 'Departments',
  'nav.users': 'Users',
  'nav.roles': 'Roles',

  'common.account': 'Account',
  'common.logout': 'Logout',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.add': 'Add',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.view': 'View',
  'common.close': 'Close',
  'common.search': 'Search...',
  'common.actions': 'Actions',
  'common.status': 'Status',
  'common.owner': 'Owner',
  'common.evidence': 'Evidence',
  'common.department': 'Department',
  'common.fiscalYear': 'Fiscal Year',
  'common.riskCode': 'Risk Code',
  'common.riskName': 'Risk Name',
  'common.riskType': 'Risk Type',
  'common.strategy': 'Strategy',
  'common.riskManagementType': 'Risk Management Type',
  'common.ermLevel': 'ERM Level',
  'common.inherent': 'Inherent Risk',
  'common.residual': 'Residual Risk',
  'common.riskId': 'Risk ID',
  'common.type': 'Type',
  'common.items': '{n} items',
  'common.impactType': 'Impact Type',
  'common.impactTo': 'Impact To',
  'common.planPeriod': 'Plan Period',
  'common.assessmentResult': 'Assessment Result',
  'common.measurementDate': 'Measurement Date',
  'common.output': 'Activity Output',
  'common.rcCode': 'RC Code',
  'common.ermRiskCode': 'ERM Risk Code',
  'common.causes': 'Causes',
  'common.internalControls': 'Internal Controls',
  'common.kri': 'KRI',
  'common.masterRisk': 'Master Risk',
  'common.masterRiskCode': 'Master Risk Code',
  'common.masterView': 'By Strategy',
  'common.allView': 'By Department',
  'common.years': 'years',
  'common.loading': 'Loading...',
  'common.likelihood': 'Likelihood',
  'common.impact': 'Impact',

  'level.high': 'High',
  'level.medium': 'Medium',
  'level.low': 'Low',
  'level.veryHigh': 'Very High',

  'strategy.R': 'Research',
  'strategy.T': 'Education',
  'strategy.A': 'Academic Services',
  'strategy.H': 'Health Services',
  'strategy.G': 'Administration',
  'rmt.Acceptance': 'Acceptance',
  'rmt.Reduction': 'Reduction',
  'rmt.Transfer': 'Transfer',
  'rmt.Avoidance': 'Avoidance',

  'erm.dept': 'Dept',
  'erm.erm': 'ERM',
  'erm.department': 'Department',
  'erm.faculty': 'Faculty (ERM)',

  'login.username': 'Username',
  'login.password': 'Password',
  'login.usernamePlaceholder': 'Enter your username',
  'login.passwordPlaceholder': 'Enter your password',
  'login.signIn': 'Sign In',
  'login.failed': 'Login failed. Please try again.',

  'dashboard.title': 'Dashboard',
  'dashboard.allDepartments': 'All Departments',
  'dashboard.allFiscalYears': 'All Fiscal Years',
  'dashboard.allLevels': 'All Levels',
  'dashboard.levelDepartment': 'Department Level',
  'dashboard.levelFaculty': 'Faculty (ERM) Level',
  'dashboard.exportDoc3': 'ERM_doc3.xlsx',
  'dashboard.exportDoc4': 'ERM_doc4.xlsx',
  'dashboard.exportDoc3Pdf': 'Document No. 3 (PDF)',
  'dashboard.exportDoc4Pdf': 'Document No. 4 (PDF)',
  'dashboard.totalRisks': 'TOTAL RISKS',
  'dashboard.highRisks': 'HIGH RISKS',
  'dashboard.mediumRisks': 'MEDIUM RISKS',
  'dashboard.lowRisks': 'LOW RISKS',
  'dashboard.veryHighRisks': 'VERY HIGH RISKS',
  'dashboard.ermLevel': 'ERM LEVEL',
  'dashboard.deptLevel': 'DEPT LEVEL',
  'dashboard.facultyLevel': 'Faculty',
  'dashboard.departmentLevel': 'Department',
  'dashboard.internalControls': 'Internal Controls',
  'dashboard.additionalControls': 'Additional Controls',
  'dashboard.kriIndicators': 'KRI Indicators',
  'dashboard.riskStatus': 'Risk Status',
  'dashboard.open': 'Open',
  'dashboard.approved': 'Approved',
  'dashboard.rejected': 'Rejected',
  'dashboard.heatMap': 'Risk Assessment',
  'dashboard.riskSummary': 'Risk Summary',
  'dashboard.highImmediate': 'Immediate action required',
  'dashboard.mediumMonitor': 'Monitor and manage',
  'dashboard.lowAcceptable': 'Acceptable level',
  'dashboard.veryHighImmediate': 'Critical - immediate action required',
  'dashboard.coverageRisks': '{a}/{b} risks covered',
  'dashboard.percentRisksPlanned': '{p}% risks have plan',
  'dashboard.kriTracking': 'Indicators being tracked',
  'dashboard.departmentTargets': 'Department Targets',
  'docs.exportSuccess': 'Exported successfully',
  'docs.exportError': 'Error exporting report',
  'docs.selectFiscalYear': 'Please select a fiscal year before exporting',

  'riskRegister.title': 'Risk Register',
  'riskRegister.addRisk': 'Add Risk',
  'riskRegister.copySelected': 'Copy Selected ({n})',
  'riskRegister.totalRisks': 'Total: {n} risks',
  'riskRegister.totalMasters': 'Total: {n} risk masters',
  'riskRegister.risksCount': '{n} risks',
  'riskRegister.inherent': 'Inherent',
  'riskRegister.residual': 'Residual',
  'riskRegister.viewExpand': 'View / Expand',
  'riskRegister.copyNextYear': 'Copy to Next Year',
  'riskRegister.elevateErm': 'Elevate to ERM',
  'riskRegister.removeErm': 'Remove from ERM',
  'riskRegister.edit': 'Edit',
  'riskRegister.delete': 'Delete',
  'riskRegister.confirmDelete': 'Delete this risk permanently? This cannot be undone.',
  'riskRegister.deleted': 'Risk deleted',
  'riskRegister.deleteError': 'Error deleting risk',
  'riskRegister.requestDelete': 'Request Deletion',
  'riskRegister.requestDeleteSuccess': 'Delete request sent to manager',
  'riskRegister.requestDeleteError': 'Error sending delete request',
  'riskRegister.pendingDeletions': 'Pending Deletions ({n})',
  'riskRegister.noPendingDeletions': 'No pending deletions',
  'riskRegister.approveDelete': 'Approve Delete',
  'riskRegister.rejectDelete': 'Reject',
  'riskRegister.approveDeleteSuccess': 'Deletion approved',
  'riskRegister.masterRisk': 'Master Risk',
  'riskRegister.createMasterRisk': 'Create Master Risk',
  'riskRegister.selectMasterRisk': 'Select Master Risk',
  'riskRegister.rejectDeleteSuccess': 'Deletion request rejected',
  'riskRegister.inherentLikelihood': 'Inherent Likelihood',
  'riskRegister.inherentImpact': 'Inherent Impact',
  'riskRegister.inherentRisk': 'Inherent Risk',
  'riskRegister.residualRisk': 'Residual Risk',
  'riskRegister.residualLikelihood': 'Residual Likelihood',
  'riskRegister.residualImpact': 'Residual Impact',
  'riskRegister.editMasterRisk': 'Edit Risk Master',
  'riskRegister.report': 'Report',
  'riskRegister.addMasterRisk': 'Add Risk Master',
  'riskRegister.addAssessment': 'Add Assessment',
  'riskRegister.editAssessment': 'Edit Assessment',
  'riskRegister.riskManagementType': 'Risk Management Type',
  'riskRegister.loadError': 'Error loading risk details',
  'riskRegister.selectAllDept': 'Select all in department',
  'riskRegister.selectRisk': 'Select {code}',

  'section.causes': 'Risk Causes ({n})',
  'section.internalControls': 'Current Controls IC ({n})',
  'section.additionalControls': 'Additional Controls AC ({n})',
  'section.kri': 'Key Risk Indicators ({n})',
  'section.addCause': 'Add Cause',
  'section.addIc': 'Add IC',
  'section.addAc': 'Add AC',
  'section.addKri': 'Add KRI',
  'section.cause': 'Cause',
  'section.noCauses': 'No causes recorded',
  'section.noIcs': 'No internal controls recorded',
  'section.noAcs': 'No additional controls recorded',
  'section.noKris': 'No KRI recorded',
  'section.noKri': 'No KRI recorded',
  'section.target': 'Target',
  'section.result': 'Result',
  'section.confirmDeleteCause': 'Delete this cause?',
  'section.confirmDeleteIc': 'Delete this internal control?',
  'section.confirmDeleteAc': 'Delete this additional control?',
  'section.confirmDeleteKri': 'Delete this KRI?',
  'section.added': 'Added successfully',
  'section.updated': 'Updated successfully',
  'section.deleted': 'Deleted successfully',
  'section.error': 'Error',

  'modal.addCause': 'Add Risk Cause',
  'modal.editCause': 'Edit Risk Cause',
  'modal.addIc': 'Add Internal Control',
  'modal.editIc': 'Edit Internal Control',
  'modal.addAc': 'Add Additional Control',
  'modal.editAc': 'Edit Additional Control',
  'modal.addKri': 'Add KRI',
  'modal.editKri': 'Edit KRI',
  'modal.causeId': 'Cause ID',
  'modal.number': 'Number',
  'modal.causeDescription': 'Cause Description',
  'modal.icId': 'IC ID',
  'modal.icNo': 'IC No',
  'modal.acId': 'AC ID',
  'modal.acNo': 'AC No',
  'modal.description': 'Description',
  'modal.icOwner': 'IC Owner',
  'modal.acOwner': 'AC Owner',
  'modal.controlType': 'Control Type',
  'modal.evidence': 'Evidence',
  'modal.autoHint': 'Auto (leave blank)',
  'modal.kriId': 'KRI ID',
  'modal.kriName': 'KRI Name',
  'modal.targetValue': 'Target Value',
  'modal.unit': 'Unit',
  'modal.kriOwner': 'KRI Owner',
  'modal.actualResult': 'Actual Result',
  'modal.actualResultPlaceholder': 'Enter actual result',
  'modal.kriForm': 'Risk Indicator',
  'modal.kriInfo': 'KRI Information',
  'modal.measurementDate': 'Measurement Date',
  'modal.output': 'Activity Result',
  'modal.outputPlaceholder': 'Enter activity result',
  'modal.outputSection': 'Activity Result (Risk Data)',
  'modal.reportResult': 'Report Result',

  'copy.title': 'Copy Risk to Next Year',
  'copy.risk': 'Risk',
  'copy.currentYear': 'Current Year',
  'copy.nextYear': 'Next Fiscal Year',
  'copy.description': 'The copy will duplicate all data (causes, IC, AC, KRI) to the next fiscal year. The original year remains unchanged. New copy starts at Department (ERM) level; an admin can elevate it later.',
  'copy.andEdit': 'Copy & Edit New Year',
  'copy.selectTargetWarning': 'Please select a target year',
  'copy.success': 'Copied to {year} successfully',
  'copy.noNextYear': 'No next fiscal year ({year}) found. Please create the fiscal year first.',
  'copy.titleBatch': 'Copy Selected Risks to Next Year',
  'copy.selected': 'Selected ({n})',
  'copy.descriptionBatch': 'Each selected risk will be copied to its own next fiscal year. Already-carried-over items are skipped automatically.',
  'copy.complete': 'Batch copy complete',
  'copy.nothing': 'Nothing copied',
  'copy.copied': 'Copied: {n}',
  'copy.alreadyExisted': 'Already existed: {n}',
  'copy.noLongerExists': 'No longer exists: {n}',
  'copy.noNextYearCount': '{n} have no next year',
  'copy.failed': 'Failed: {list}',
  'copy.copying': 'Copying...',
  'copy.copyCount': 'Copy {n} Risk{n2}',
  'copy.copiedTo': 'Copied to {year} successfully',

  'form.titleNew': 'Register New Risk',
  'form.titleEdit': 'Edit Risk',
  'form.alertNew': 'Register a new risk. After creation, you can add causes, controls, and KRI from the Risk Register page.',
  'form.alertEdit': 'Edit the risk details below.',
  'form.riskId': 'Risk ID',
  'form.riskCode': 'Risk Code',
  'form.department': 'Department',
  'form.fiscalYear': 'Fiscal Year',
  'form.riskType': 'Risk Type',
  'form.strategy': 'Strategy',
  'form.riskManagementType': 'Risk Management Type',
  'form.riskOwner': 'Risk Owner',
  'form.ermLevel': 'ERM Level',
  'form.riskName': 'Risk Name',
  'form.riskIdPlaceholder': 'e.g. RM-0001',
  'form.riskIdAuto': 'Auto-generated when you save',
  'form.riskCodePlaceholder': 'e.g. OR01',
  'form.selectDepartment': 'Select department',
  'form.selectFiscalYear': 'Select fiscal year',
  'form.selectRiskType': 'Select risk type',
  'form.selectStrategy': 'Select strategy',
  'form.selectRmt': 'Select RMT',
  'form.riskOwnerPlaceholder': 'Risk owner name',
  'form.riskNamePlaceholder': 'Describe the risk...',
  'form.inherentLikelihood': 'Inherent Likelihood',
  'form.inherentImpact': 'Inherent Impact',
  'form.residualLikelihood': 'Residual Likelihood',
  'form.residualImpact': 'Residual Impact',
  'form.inherentRisk': 'Inherent Risk',
  'form.residualRisk': 'Residual Risk',
  'form.riskAssessment': 'Risk Assessment',
  'form.createRisk': 'Register Risk',
  'form.updateRisk': 'Update Risk',
  'form.cancel': 'Cancel',
  'form.fillRequired': 'Please fill in all required fields',
  'form.updatedSuccess': 'Risk updated successfully',
  'form.createdSuccess': 'Risk registered successfully',
  'form.createdHeading': 'Risk Registered Successfully',
  'form.registerAnother': '+ Register Another Risk',
  'form.savedMessage': 'Risk <b>{code}</b> has been saved. You can edit, delete, or add causes/controls from the Risk Register.',
  'form.backToRegister': 'Back to Register',
  'form.editRisk': 'Edit Risk',
  'form.deleteRisk': 'Delete Risk',
  'form.deletedSuccess': 'Risk deleted',
  'form.saveError': 'Error saving risk',
  'form.deleteError': 'Error deleting',
  'form.riskNameLabel': 'Risk Name',
  'form.impactType': 'Impact Type',
  'form.impactTo': 'Impact To',
  'form.planStartMonth': 'Start Month',
  'form.planEndMonth': 'End Month',
  'form.assessmentResult': 'Existing Control Assessment Result',
  'form.output': 'Activity Output',
  'form.outputPlaceholder': 'Enter activity output',
  'form.selectOption': 'Select',
  'form.rcCode': 'RC Code',
  'form.ermRiskCode': 'ERM Risk Code',
  'form.riskCodeAuto': 'Auto-generated when you save',

  'dept.title': 'Departments',
  'dept.add': 'Add Department',
  'dept.unitId': 'Unit ID',
  'dept.departmentName': 'Department Name',
  'dept.workUnit': 'Work Unit',
  'dept.targets': 'Targets',
  'dept.risks': 'Risks',
  'dept.addTitle': 'Add Department',
  'dept.editTitle': 'Edit Department',
  'dept.unitIdPlaceholder': 'e.g. DEP-01',
  'dept.namePlaceholder': 'Department name',
  'dept.workUnitPlaceholder': 'Optional work unit',
  'dept.updatedSuccess': 'Updated successfully',
  'dept.createdSuccess': 'Created successfully',
  'dept.deletedSuccess': 'Deleted successfully',
  'dept.saveError': 'Error saving',
  'dept.deleteError': 'Error deleting',
  'dept.confirmDelete': 'Are you sure you want to delete this department?',
  'dept.view': 'View',
  'dept.recentActivity': 'Recent Activity ({n})',
  'dept.noActivity': 'No activity',
  'dept.relatedTargets': 'Related Targets ({n})',
  'dept.noTargets': 'No targets found.',
  'dept.targetId': 'Target ID',
  'dept.targetNo': 'No.',
  'dept.targetDescription': 'Description',
  'dept.relatedRisks': 'Related Risks ({n})',
  'dept.noRisks': 'No risks found.',
  'dept.riskName': 'Risk Name',
  'dept.riskType': 'Type',

  'users.title': 'User Management ({n})',
  'users.addUser': 'Add User',
  'users.export': 'Export',
  'users.username': 'Username',
  'users.fullName': 'Full Name',
  'users.email': 'Email',
  'users.role': 'Role',
  'users.status': 'Status',
  'users.admin': 'Admin',
  'users.user': 'User',
  'users.active': 'Active',
  'users.inactive': 'Inactive',
  'users.noDept': 'No department',
  'users.addTitle': 'Add User',
  'users.editTitle': 'Edit: {name}',
  'users.department': 'Department',
  'users.selectDept': 'Select department',
  'users.newPassword': 'New Password',
  'users.password': 'Password',
  'users.usernamePlaceholder': 'e.g. somchai.k',
  'users.namePlaceholder': 'Full name',
  'users.emailPlaceholder': 'email@mahidol.ac.th',
  'users.passwordPlaceholder': 'Enter or generate password',
  'users.newPasswordPlaceholder': 'Enter new password',
  'users.generate': 'Generate',
  'users.copy': 'Copy',
  'users.passwordCopied': 'Password copied!',
  'users.keepCurrentPassword': 'Leave blank to keep current password',
  'users.fillRequired': 'Please fill all required fields',
  'users.updatedSuccess': 'Updated successfully',
  'users.createdSuccess': 'Created successfully',
  'users.deletedSuccess': 'Deleted successfully',
  'users.saveError': 'Error',
  'users.deleteError': 'Error deleting',
  'users.confirmDelete': 'Are you sure you want to delete this user?',
  'users.genPasswordError': 'Error generating password',
  'users.exportError': 'Error exporting',
  'users.show': 'Show',
  'users.hide': 'Hide',
  'users.selectRoleHint': 'Hold Ctrl/Cmd to select multiple roles',

  'roles.title': 'Role Management',
  'roles.addRole': 'Add Role',
  'roles.name': 'Role Name',
  'roles.users': 'Users',
  'roles.addTitle': 'Add New Role',
  'roles.editTitle': 'Edit Role',
  'roles.namePlaceholder': 'Role name',
  'roles.fillRequired': 'Please enter a role name',
  'roles.updatedSuccess': 'Role updated successfully',
  'roles.createdSuccess': 'Role created successfully',
  'roles.saveError': 'Error saving role',
  'roles.confirmDelete': 'Are you sure you want to delete this role?',
  'roles.deletedSuccess': 'Role deleted successfully',
  'roles.deleteError': 'Error deleting role',
  'roles.assignUsers': 'Assign Users',
  'roles.assignTitle': 'Assign Users to Role: {role}',
  'roles.noUsers': 'No users in the system',
  'roles.assignSuccess': 'User assignments saved',
  'roles.assignError': 'Error saving user assignments',

  'heatmap.impact': 'Impact ↑',
  'heatmap.likelihood': 'Likelihood →',
  'heatmap.tooltip': 'Likelihood: {l} × Impact: {i} = {s} | Level: {lv} | Risks: {c}',
  'heatmap.legend': 'Risk Level: Green: Low | Yellow: Medium | Orange: High | Red: Very High',
  'heatmap.noData': 'No data',

  'icac.title': 'IC/AC Plan & Evidence Coverage',
  'icac.totalMasters': 'Total Risk Masters',
  'icac.mastersWithIc': 'Masters with IC plan',
  'icac.mastersWithAc': 'Masters with AC plan',
  'icac.icWithEvidence': 'IC plans with evidence',
  'icac.acWithEvidence': 'AC plans with evidence',

  'pb.byCategory': 'Total Risks by Risk Category',
  'pb.byDepartment': 'Total Risks by Department',
  'pb.byDepartmentInherent': 'Total Risks by Department and Inherent Risk',
  'pb.deptAnalysis': 'Department Analysis',
  'pb.avgInherentVsResidual': 'Avg Inherent vs Avg Residual Score by Department (assessed only)',
  'pb.deptSummary': 'Department Summary',
  'pb.residualCompleteness': 'Residual Data Completeness: {p}% ({a}/{t})',
  'pb.residualHeatMap': 'Residual Risk Assessment',
  'pb.avgControls': 'Avg Controls by Department',
  'pb.riskDetails': 'Risk Details List',
  'pb.avgInherent': 'Avg Inherent',
  'pb.avgResidual': 'Avg Residual',
  'pb.totalRisks': 'Total Risks',
  'pb.total': 'Total',
  'pb.riskCode': 'Risk Code',
  'pb.riskName': 'Risk Name',
  'pb.inherentRisk': 'Inherent Risk',
  'pb.department': 'Department',

  'upload.uploadEvidence': 'Upload Evidence',
  'upload.replaceFile': 'Replace File',
  'upload.uploaded': 'File uploaded',
  'upload.failed': 'Upload failed',
  'upload.view': 'View file (in-app)',
  'upload.remove': 'Remove',
  'upload.evidence': 'Evidence',
};

export const translations: Record<Lang, Record<string, string>> = { th, en };
